import moment from 'moment';
const API_DATE_FORMAT = 'DD-MM-YYYY HH:mm';

export function importDate(value) {
    if (!value) return null;
    return moment(value, API_DATE_FORMAT).toDate();
}

export function exportDate(value) {
    return moment(value).format(API_DATE_FORMAT);
}

export function exportDateShort(value) {
    return moment(value).format('DD-MM-YYYY');
}



// WEBPACK FOOTER //
// ./src/api/dateformat.js